import { ROLES } from "shared/config";
import { getRejectionData } from "./getRejectionData";

export const getCostLineDecisions = (costLine, userRole) => {
  const rejectionData = getRejectionData(
    costLine?.acceptations,
    costLine?.rejection_history
  );

  let isAccepted = false;
  let isRejected = false;

  const acceptation = costLine?.acceptations?.data?.decision === "Accepted";

  if (acceptation) {
    if ([ROLES.USER, ROLES.ACCOUNTS_PAYABLE].includes(userRole)) {
      isAccepted = rejectionData === null;
    } else {
      isAccepted = rejectionData?.acceptor_role !== userRole;
    }
  }

  if (rejectionData !== null) {
    if (userRole === ROLES.ACCOUNTS_PAYABLE) {
      isRejected = true;
    } else if (userRole === ROLES.USER) {
      isRejected = rejectionData.acceptor_role !== ROLES.COST_GROUP;
    } else {
      isRejected = rejectionData.acceptor_role === userRole;
    }
  }

  return { isAccepted, isRejected };
};
